export default __webpack_public_path__ + "static/media/isip_icon.d2b44a61.svg";